import {gsap} from 'gsap';
import {ScrollTrigger} from 'gsap/ScrollTrigger.js';
import {CustomEase} from 'gsap/CustomEase';
import {ScrollSmoother} from 'gsap/ScrollSmoother';

gsap.registerPlugin( ScrollTrigger, CustomEase, ScrollSmoother );
( function( app ) {
  const COMPONENT = {
    init: function() {
      const _this = this;
    },
    finalize: function() {
    },
    animate: function() {
      const query = window.matchMedia( '(prefers-reduced-motion: reduce)' );

      if ( query.matches ) {
        // DO NOT FIRE ANIMATIONS BUT GO AHEAD AND SET FADE UPS TO VISIBLE
        $( '.fade-up' ).each( function() {
          $( this ).css( 'opacity', '1' );
        } );
      } else if ( !query.matches && window.innerWidth < 769 ) {
        // ONLY FIRE THIS SMALL SIMPLER ANIMATION ON MOBILE AND GO AHEAD AND SET FADE UPS TO VISIBLE
        $( '.fade-up' ).each( function() {
          $( this ).css( 'opacity', '1' );
        } );
      } else {
        llParallax();
        llParallaxTop();
        llParallaxMiddle();
        llParallaxBottom();
        llParallaxSection();
        fadeUp();
      }

      function llParallax() {
        $( '.ll-parallax' ).each( function() {
          let speed = $( this ).data( 'speed' );
          let speedNeg = 0;
          if ( speed != null ) {
            speedNeg = '-'+speed;
          } else {
            speed = 15;
            speedNeg = -15;
          }
          const tl = gsap.timeline( {
            scrollTrigger: {
              trigger: this,
              start: 'top bottom',
              end: 'bottom top',
              pin: false,
              scrub: 1.25,
              delay: 1,
              // markers: true,
              id: 'parallax-default',
            },
          } );
          tl.fromTo( $( this ), {yPercent: speed}, {yPercent: speedNeg} );
        } );
      }

      function llParallaxSection() {
        $( '.ll-parallax-section' ).each( function() {
          const tl = gsap.timeline( {
            scrollTrigger: {
              trigger: this,
              start: 'top bottom',
              end: 'bottom top',
              pin: false,
              scrub: 1.25,
              // markers: true,
              id: 'parallax-section',
            },
          } );
          tl.fromTo( $( this ), {yPercent: 10}, {yPercent: -10} );
        } );
      }

      function llParallaxTop() {
        $( '.ll-parallax-top' ).each( function() {
          const tl = gsap.timeline( {
            scrollTrigger: {
              trigger: this,
              start: 'top top+=20%',
              end: 'bottom top-=50%',
              pin: false,
              scrub: 1.5,
              delay: 0.25,
              // markers: true,
              id: 'parallax-top',
            },
          } );
          tl.to( $( this ), {yPercent: -15} );
        } );
      }

      function llParallaxMiddle() {
        $( '.ll-parallax-middle' ).each( function() {
          const tl = gsap.timeline( {
            scrollTrigger: {
              trigger: this,
              start: 'top center',
              end: 'bottom top',
              pin: false,
              scrub: 1.5,
              delay: 0.25,
              // markers: true,
              id: 'parallax-middle',
            },
          } );
          tl.to( $( this ), {yPercent: -70} );
        } );
      }

      function llParallaxBottom() {
        $( '.ll-parallax-bottom' ).each( function() {
          const tl = gsap.timeline( {
            scrollTrigger: {
              trigger: this,
              start: 'top center+=10%',
              end: 'bottom top',
              pin: false,
              scrub: 1.5,
              delay: 0.25,
              // markers: true,
              id: 'parallax-bottom',
            },
          } );
          tl.to( $( this ), {yPercent: -110} );
        } );
      }


      function fadeUp() {
        if ( $( '.fade-up' ).length > 0 ) {
          const fadeUp = gsap.timeline();
          fadeUp.fromTo( '.fade-up', {opacity: 0, yPercent: 30, stagger: 0.1}, {opacity: 1, yPercent: 0, stagger: 0.1} );
        }
      }
    },
  };
  app.registerComponent( 'animations', COMPONENT );
} )( app );
